import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import styles from '../assets/css/module/common.module.css'
import { useState } from 'react';
import dayjs from 'dayjs'
import { saveAs } from 'file-saver';
// import XMLViewer from 'react-xml-viewer';
import Select from 'react-select';
import { enqueueSnackbar } from 'notistack';

import Papa from "papaparse";
const { buildGPX, GarminBuilder } = require('gpx-builder');

const { Point } = GarminBuilder.MODELS;
var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
const Home = () => {
  const [data, setData] = useState([]);
  const [file, setFile] = useState("");
  const [type, setType] = useState({ value: 1, label: 'Spidertrack', idntf: 'Aircraft' });
  const [convertDisable, setConvertDisable] = useState(true);
  const [headerCSV, setHeaderCSV] = useState([]);
  // const [result, setResult] = useState(null);

  const typeOpt = [
    { value: 1, label: 'Spidertrack', idntf: 'Aircraft' },
    { value: 2, label: 'Garmin Aircraft System', idntf: '#airframe_info' },
    { value: 3, label: 'Flight Radar', idntf: 'Timestamp' }
  ]

  const stylesSelect = {
    control: (base, state) => ({
      ...base,
      height: '36.5px',
      width: '220px',
      maxWidth: '220px',
      minHeight: '36.5px',
      borderColor: '#ced4da',
      borderRadius: '5px',
      lineHeight: '1.5',
      textAlign: 'left'
      // marginTop: '0'
    }),
    valueContainer: base => ({
      ...base,
      margin: 0,
      height: '100%',
      padding: '0 0.5rem',
      transform: 'translateY(-5%)',
    }),
    indicatorSeparator: base => ({
      ...base,
      display: 'none',
    }),
    placeholder: base => ({
      ...base,
      fontSize: '0.8rem',
      color: "#bebebe",
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    }),
    menu: styles => ({ ...styles, zIndex: 9999, width: '220px', maxWidth: '220px', overflow: 'visible', position: 'absolute', textAlign: 'left' }),
    menuList: styles => ({ ...styles, width: '220px', maxWidth: '220px', whiteSpace: 'wrap', textOverflow: 'ellipsis', textAlign: 'left' })
  };

  const fileHandle = (e) => {
    setFile(e.target.files[0])
    Papa.parse(e.target.files[0], {
      worker: true,
      delimiter: ",",
      header: false,
      complete: (result) => {
        let identifier = result.data[0][0]

        if (type.idntf === identifier) {
          let tmparr = result.data
          if (type.value === 2) {
            tmparr = tmparr.filter(item => item !== result.data[0])
            tmparr = tmparr.filter(item => item !== result.data[1])
            tmparr = tmparr.filter(item => item !== result.data[2])
          } else {
            tmparr = tmparr.filter(item => item !== result.data[0])
          }
          tmparr.pop()
          setHeaderCSV(result.data[0])
          setData(tmparr);
          setConvertDisable(false)
        } else {
          enqueueSnackbar(`File Not Match Template`, { variant: "error", autoHideDuration: 1000 })
	  setFile("")
        }
      }
    }
    );
  };

  const exporttogpx = (e) => {
    let sc = null
    try {
      if (!convertDisable) {
        let tmpPoint = []
        if (type.value === 1) {
          data.map(x => {
            tmpPoint.push(
              new Point(x[9], x[14], {
                time: new Date(dayjs.utc(x[3], "MM-DD-YYYY H:mm").format()),
                ele: parseFloat((parseFloat(x[15]) * 0.3048).toFixed(2)),
                // ele: parseFloat(x[15]),
                // hr: 120,
                speed: parseFloat(x[16]),
                bearing: parseFloat(x[17]),
              })
            )
          })
        } else if (type.value === 2) {
          data.map(x => {
            if (dayjs.utc(`${x[0]}${x[1]}`, "YYYY-MM-DD HH:mm:ss").isValid()) {
              tmpPoint.push(
                new Point(x[4], x[5], {
                  time: new Date(dayjs.utc(`${x[0]}${x[1]}`, "YYYY-MM-DD HH:mm:ss").format()),
                  ele: parseFloat((parseFloat(x[6]) * 0.3048).toFixed(2)),
                  // ele: parseFloat(x[15]),
                  // hr: 120,
                  speed: parseFloat(x[11]),
                  bearing: parseFloat(x[17]),
                })
              )
            }
          })
        } else if (type.value === 3) {
          data.map(x => {
            let loc = x[3].split(',')
            tmpPoint.push(
              new Point(loc[0], loc[1], {
                time: new Date(dayjs.utc(x[1]).format()),
                ele: parseFloat((parseFloat(x[4]) * 0.3048).toFixed(2)),
                // ele: parseFloat(x[15]),
                // hr: 120,
                speed: parseFloat(x[5]),
                bearing: parseFloat(x[6]),
              })
            )
          })
        }

        const gpxData = new GarminBuilder();
        gpxData.setSegmentPoints(tmpPoint);
        let rs = buildGPX(gpxData.toObject()).substring(buildGPX(gpxData.toObject()).indexOf("\n") + 1)
        // setResult(rs)
        saveAs(new Blob([rs]), "output.gpx");
        sc = true
      }
    } catch (error) {
      enqueueSnackbar(`Convert Error`, { variant: "error", autoHideDuration: 1000 })
      sc = false
    } finally {

      if (sc !== null) {
        if (sc) {
          enqueueSnackbar(`Convert Done`, { variant: "success", autoHideDuration: 1000 })
          setConvertDisable(true)
          setFile("")
        }
      }
    }
  }

  return (
    <div>
      <div>
        <div className={`${styles["container"]}`}>
          <div>
            <Select
              className={styles['select']}
              value={type}
              styles={stylesSelect}
              name="type"
              options={typeOpt}
              placeholder={'Please Select Source Type'}
              onChange={setType}
            />
          </div>
          <div className={`${styles["btn-dv"]}`}>
            <Button component="label" variant="contained" startIcon={<CloudUploadIcon />}>
              Browse File CSV
              <VisuallyHiddenInput type="file" accept='.csv,.CSV' onChange={e => fileHandle(e)} />
            </Button>
            <Button variant="contained" onClick={exporttogpx} disabled={convertDisable}>Convert to GPX</Button>
          </div>
          <div>
            <p>{file.name}</p>
          </div>

        </div>
        {/* <div className={`${styles["a-dv"]}`}>
          <div>
            <p>{file.name}</p>
          </div>
          <div className={`${styles["rs-sec"]}`}>
            <XMLViewer xml={result !== null ? result : ''} />
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default Home;
